__turbopack_context__.v({
  "content": "UspBarBlok-module__BLhE_G__content",
  "root": "UspBarBlok-module__BLhE_G__root",
});
